import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { getHomehealthagency } from './home-health-agency.model';

@Injectable({
    providedIn: 'root'
})
export class HHADataService extends Subject<DataStateChangeEventArgs> {
    constructor(private http: HttpClient, public errorService: ErrorService) {
        super();
    }
    public execute(State: getHomehealthagency): void {
        this.getFmsFilter(State).subscribe(x => super.next(x));
    }
    getFmsFilter(State?: getHomehealthagency): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>("api/HHAgency/GetHHAgencyList", State)
            .pipe(map(
                (response: any) =>
                    <any>{
                        result: response['result'],
                        count: response['count']
                    }
            ))
    }
}
